var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{key:_vm.$route.path}),_vm._v(" "),_c('DropOverlay'),_vm._v(" "),(_vm.showPasswordPrompt)?_c('DialogEnterLanguagePassword',{on:{"ok":_vm.successfulLogin}}):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76856738","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/AppLanguages.vue
// module id = jPKv
// module chunks = 1